import styled, { css, keyframes, withTheme } from 'styled-components';

import BaseButton from './base-button';

const animation = keyframes`
    0% {
        transform: scale(1) rotate(0deg);
    }
    100% {
        transform: scale(1) rotate(360deg);
    }
`;

const animationRule = css`
  ${animation} 2s infinite linear;
`;

const ToolMiscButton = styled(BaseButton)`
    &.btn {
        &.btn-primary, &.btn-primary:focus, &.btn-primary:active {
            transform: none;
            border-radius:0;
            display:block;
            width:100%;
            text-align: left;            
            outline:none !important;
            box-shadow:none !important;
            border:thin solid transparent;
            color: ${props => props.theme.$dark};
            font-family: ${props => props.theme['$font-family-sans-serif']} !important;
            font-weight: 400 !important;
            background: transparent;
            border: 2px solid ${props => props.theme.$gold};
            background-color: ${props => props.theme.$gold};
            color: ${props => props.theme.$white};
            padding-right:15px;
            white-space:normal;
            position:relative;
            svg {
                margin:0 0 0 5px;
                animation: ${animationRule};
            }
            .icon {
                position:absolute;
                top:6px;
                right:6px;
                width:24px;
                height:24px;
                display:inline-block;
                background-size: 24px 24px;
                margin:0 0 0 5px;
            }
            &.disabled {
                cursor: not-allowed! important;
                opacity:0.2;
                opacity:0.2;
                border: 2px solid ${props => props.theme.$gold};
                background-color: ${props => props.theme.$white};
                color: ${props => props.theme.$gold};

                &:hover {
                    opacity:0.2;
                    border: 2px solid ${props => props.theme.$gold};
                    background-color: ${props => props.theme.$white};
                    color: ${props => props.theme.$gold};
                }
                .icon {
                    display:none;
                }
            }
            &:hover {
                border: 2px solid ${props => props.theme.$gold};
                background-color: ${props => props.theme.$white};
                color: ${props => props.theme.$gold};
            }
        }
    
    }
`;

export default withTheme(ToolMiscButton);
